import * as React from "react";
import { TourButton } from "./tourButton/TourButton";
import { Footer } from "./footer/Footer";
import { StepsCounter } from "./stepsCounter/StepsCounter";
export function MultiStepFooter(props) {
    if (!props.stepsCount) {
        return null;
    }
    var renderNextButton = function (innerText, needArrow) {
        if (needArrow === void 0) { needArrow = true; }
        return (React.createElement(TourButton, { onClick: function () { var _a; return (_a = props.onNext) === null || _a === void 0 ? void 0 : _a.call(props); }, use: props.blueBackground ? undefined : "primary", arrow: needArrow ? "right" : undefined }, props.nextButtonText || innerText || "Далее"));
    };
    var renderPrevButton = function (innerText, needArrow) {
        if (needArrow === void 0) { needArrow = true; }
        return (React.createElement(TourButton, { onClick: function () { var _a; return (_a = props.onPrev) === null || _a === void 0 ? void 0 : _a.call(props); }, arrow: needArrow ? "left" : undefined, blueBackground: props.blueBackground, use: props.blueBackground ? "primary" : undefined }, props.prevButtonText || innerText || "Назад"));
    };
    var points = (React.createElement(StepsCounter, { stepsCount: props.stepsCount, activeStepIndex: props.activeStepIndex, blueBackground: props.blueBackground }));
    var leftPartContent;
    var centerPartContent = points;
    var rightPartContent;
    if (props.stepsCount === 1) {
        centerPartContent = null;
        leftPartContent = renderNextButton("Приступить", false);
    }
    else if (props.activeStepIndex === 1) {
        leftPartContent = renderNextButton();
    }
    else if (props.activeStepIndex === props.stepsCount) {
        leftPartContent = renderPrevButton();
        rightPartContent = renderNextButton("Приступить", false);
    }
    else if (props.activeStepIndex > props.stepsCount) {
        leftPartContent = renderPrevButton();
        centerPartContent = null;
        rightPartContent = renderNextButton("Приступить", false);
    }
    else {
        leftPartContent = renderPrevButton();
        rightPartContent = renderNextButton();
    }
    return (React.createElement(Footer, null,
        React.createElement(Footer.LeftPart, null, leftPartContent),
        React.createElement(Footer.RightPart, null, rightPartContent),
        React.createElement(Footer.StepsCounterPart, null, centerPartContent)));
}
